class FooterNewsletter extends HTMLElement {
  constructor() {
    super()

    this.formEl = this.querySelector('form')
    this.inputEl = this.querySelector('.js-form-input')
    this.messageEl = this.querySelector('.js-form-alert')
    this.submitEl = this.querySelector('.js-form-submit')
    this.listIdEl = this.querySelector('[name="g"]')

    if (this.formEl) {
      this.formEl.addEventListener('submit', this.onFormSubmit.bind(this))
    }
  }

  parseJSON (string) {
    let json = {}
    string = string.replace(/<!--.*-->/g, '')
    try {
      json = JSON.parse(string)
    } catch (e) {
      console.log(e)
    }
    return json
  }

  async onFormSubmit (event) {
    event.preventDefault()

    this.messageEl.style.display = 'none'

    if (!this.inputEl || !this.listIdEl) {
      return
    }

    this.inputEl.classList.remove('has-error')

    this.query = {
      email: this.inputEl.value,
      g: this.listIdEl.value
    }

    const isValid = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const checkValid = isValid.test(this.inputEl.value)

    if (!checkValid) {
      event.preventDefault()
      this.inputEl.classList.add('has-error')
      return this.showError('Please enter a valid email address')
    }

    const query = Object.keys(this.query).map(k => {
      let value = this.query[k]
      return `${k}=${value}`
    }).join('&')

    if (window.klaviyo && this.query.email) {
      await window.klaviyo.identify({
        email: this.query.email
      })
    }

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      body: query,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
    })
      .then((response) => response.text())
      .then((responseText) => {
        const parsed = this.parseJSON(responseText)
        if (parsed && parsed['success']) {
          this.showSuccess()
        } else {
          this.showError('Whoops, something went wrong')
          console.error('newsletter', parsed)
        }
      })
  }

  showSuccess () {
    this.inputEl.style.display = 'none'
    this.submitEl.style.display = 'none'
    this.messageEl.innerHTML = this.messageEl.dataset.success
    this.messageEl.classList.remove('Alert--error')
    this.messageEl.classList.add('Alert--success')
    this.messageEl.style.display = 'block'
  }

  showError (errorMessage) {
    this.messageEl.innerHTML = errorMessage
    this.messageEl.classList.remove('Alert--success')
    this.messageEl.classList.add('Alert--error')
    this.messageEl.style.display = 'block'
  }
}

customElements.define('footer-newsletter', FooterNewsletter)
